import React from 'react';
import { motion } from 'framer-motion';
interface FloatingElementsProps {
  count?: number;
  colors?: string[];
}
export function FloatingElements({
  count = 6,
  colors = ['bg-rose', 'bg-gold', 'bg-cream-dark']
}: FloatingElementsProps) {
  // Generate deterministic random values to avoid hydration mismatch
  const elements = Array.from({
    length: count
  }).map((_, i) => ({
    id: i,
    size: 40 + i * 17 % 120,
    left: `${i * 23 % 100}%`,
    top: `${i * 37 % 100}%`,
    duration: 15 + i * 7 % 20,
    delay: i * 3 % 10,
    color: colors[i % colors.length]
  }));
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-284">
      {elements.map(el => <motion.div key={el.id} className={`absolute rounded-full opacity-[0.15] blur-3xl ${el.color}`} style={{
      width: el.size,
      height: el.size,
      left: el.left,
      top: el.top
    }} animate={{
      y: [0, -100, 0],
      x: [0, 50, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: el.duration,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: el.delay
    }} data-id="element-285" />)}
    </div>;
}